<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card v-if="box != null" class="green lighten-5 pa-1">            
        <Title :title="box.box.name">
            <v-spacer />
            <TitleButton
                color="primary"
                icon="mdi-keyboard-return"
                name="一覧に戻る"
                @click="box = null" />
        </Title>
        <v-container fluid class="pa-0">
            <v-row dense>
                <v-col>
                    <CurrentValueList :box="box" :sensors="sensors" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <v-expand-transition>
                        <SensorList :sensors="sensors" />
                    </v-expand-transition>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import CurrentValueList from '@/components/box/SensorCurrentValueList';
    import SensorList from '@/components/box/SensorList';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        props: {
            /** 一覧で選択されたボックス */
            value: null
        },
        components: {
            Title,
            TitleButton,
            CurrentValueList,
            SensorList,
            Confirm,
        },
        data: function () {
            return {
                sensors: []
            }
        },
        computed: {
            /** 一覧で選択されたボックス */
            box: {
                get: function () {
                    return this.$props.value
                },
                set: function (value) {
                    this.$emit("input", value)
                }
            },
        },
        created: function () {
            const self = this
            this.sensors = []
            this.box.master.sensors.forEach(function(sensor) {
                const sensorData = {
                    boxMaster: self.box.master,
                    body: sensor,
                    isVisible: false,
                    yAxis: 1,
                    measureInformation: null,
                    alarmHistories: [],
                    chart: null
                }
                self.sensors.push(sensorData)
                console.log(sensorData)
            })
        },
        beforeDestroy: function () {
            console.log("Box.beforeDestroy")
        },
        methods: {
        }
    }
</script>
